module.exports = __webpack_public_path__ + "img/10.364e4848.png";